import React, { useState, useEffect } from "react";
import {
    collection,
    getDocs,
    setDoc,
    doc,
    Timestamp
} from "firebase/firestore";
import { db } from "../firebase";
import Loader from "../components/Loader";

const COLLECTION_NAME = "COMPANY_PROFILE";
const PROFILE_ID = "main_profile";

export default function Profile() {
    const [profile, setProfile] = useState({
        companyName: "",
        address: "",
        city: "",
        state: "Tamil Nadu (33)",
        pincode: "",
        phone: "",
        email: "",
        website: "",
        gstin: "",
        bankName: "",
        accNumber: "",
        ifscCode: "",
        upiId: "",
        invPrefix: "INV-",
        invNext: 1,
        qtnPrefix: "QT-",
        qtnNext: 1,
        profPrefix: "PI-",
        profNext: 1,
        dcPrefix: "DC-",
        dcNext: 1
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [activeTab, setActiveTab] = useState("GENERAL");

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        setLoading(true);
        try {
            const snap = await getDocs(collection(db, COLLECTION_NAME));
            if (!snap.empty) {
                const data = snap.docs[0].data();
                setProfile(prev => ({ ...prev, ...data }));
            }
        } catch (err) {
            console.error("Error fetching profile:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await setDoc(doc(db, COLLECTION_NAME, PROFILE_ID), {
                ...profile,
                updatedAt: Timestamp.now()
            });
            alert("Profile saved successfully");
        } catch (err) {
            console.error("Error saving profile:", err);
            alert("Failed to save profile");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <div className="container-fluid mt-3 pb-5 px-4">
            <div className="card shadow-sm border-0">
                <div className="card-header bg-white py-3 border-bottom-0">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div>
                            <h4 className="mb-0 text-primary">Company Profile</h4>
                            <p className="text-muted small mb-0">Manage your business details, banking, and document settings.</p>
                        </div>
                        <button
                            type="button"
                            className="btn btn-primary shadow-sm px-4"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? <span className="spinner-border spinner-border-sm me-2" /> : <i className="bi bi-check2-circle me-2"></i>}
                            Save Profile
                        </button>
                    </div>
                </div>

                <div className="card-body pt-0">
                    <ul className="nav nav-tabs mb-4">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "GENERAL" ? "active fw-bold" : ""}`}
                                onClick={() => setActiveTab("GENERAL")}
                            >
                                <i className="bi bi-info-circle me-2"></i>General Profile
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "BANKING" ? "active fw-bold" : ""}`}
                                onClick={() => setActiveTab("BANKING")}
                            >
                                <i className="bi bi-bank me-2"></i>Banking Details
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "SETTINGS" ? "active fw-bold" : ""}`}
                                onClick={() => setActiveTab("SETTINGS")}
                            >
                                <i className="bi bi-gear me-2"></i>Invoice Settings
                            </button>
                        </li>
                    </ul>

                    <form onSubmit={handleSave}>
                        <div className="row g-4">
                            {activeTab === "GENERAL" && (
                                <>
                                    <div className="col-12">
                                        <h6 className="text-uppercase text-muted border-bottom pb-2 mb-3">Business Details</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Company Name</label>
                                        <input
                                            className="form-control"
                                            required
                                            value={profile.companyName}
                                            onChange={e => setProfile({ ...profile, companyName: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">GSTIN</label>
                                        <input
                                            className="form-control text-uppercase"
                                            value={profile.gstin}
                                            onChange={e => setProfile({ ...profile, gstin: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label fw-bold">Office Address</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            required
                                            value={profile.address}
                                            onChange={e => setProfile({ ...profile, address: e.target.value })}
                                        ></textarea>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold">City</label>
                                        <input
                                            className="form-control"
                                            value={profile.city}
                                            onChange={e => setProfile({ ...profile, city: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold">State</label>
                                        <input
                                            className="form-control"
                                            value={profile.state}
                                            onChange={e => setProfile({ ...profile, state: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold">Pincode</label>
                                        <input
                                            className="form-control"
                                            value={profile.pincode}
                                            onChange={e => setProfile({ ...profile, pincode: e.target.value })}
                                        />
                                    </div>

                                    <div className="col-12 mt-5">
                                        <h6 className="text-uppercase text-muted border-bottom pb-2 mb-3">Contact Information</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold">Phone</label>
                                        <input
                                            className="form-control"
                                            value={profile.phone}
                                            onChange={e => setProfile({ ...profile, phone: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold">Email</label>
                                        <input
                                            className="form-control"
                                            value={profile.email}
                                            onChange={e => setProfile({ ...profile, email: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold">Website</label>
                                        <input
                                            className="form-control"
                                            value={profile.website}
                                            onChange={e => setProfile({ ...profile, website: e.target.value })}
                                        />
                                    </div>
                                </>
                            )}

                            {activeTab === "BANKING" && (
                                <>
                                    <div className="col-12">
                                        <h6 className="text-uppercase text-muted border-bottom pb-2 mb-3">Bank Details (For Payments)</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Bank Name</label>
                                        <input
                                            className="form-control"
                                            value={profile.bankName}
                                            onChange={e => setProfile({ ...profile, bankName: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Account Number</label>
                                        <input
                                            className="form-control"
                                            value={profile.accNumber}
                                            onChange={e => setProfile({ ...profile, accNumber: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">IFSC Code</label>
                                        <input
                                            className="form-control text-uppercase"
                                            value={profile.ifscCode}
                                            onChange={e => setProfile({ ...profile, ifscCode: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">UPI ID (VPA) for QR</label>
                                        <input
                                            className="form-control"
                                            placeholder="e.g. company@bank"
                                            value={profile.upiId}
                                            onChange={e => setProfile({ ...profile, upiId: e.target.value })}
                                        />
                                    </div>
                                </>
                            )}

                            {activeTab === "SETTINGS" && (
                                <>
                                    <div className="col-12">
                                        <h6 className="text-uppercase text-muted border-bottom pb-2 mb-3">Document Sequence Settings</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card bg-light border-0">
                                            <div className="card-body">
                                                <label className="form-label fw-bold">Invoice (Prefix & Next Serial)</label>
                                                <div className="input-group">
                                                    <input className="form-control" placeholder="Prefix" value={profile.invPrefix} onChange={e => setProfile({ ...profile, invPrefix: e.target.value })} />
                                                    <input type="number" className="form-control" placeholder="Next #" value={profile.invNext} onChange={e => setProfile({ ...profile, invNext: Number(e.target.value) })} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card bg-light border-0">
                                            <div className="card-body">
                                                <label className="form-label fw-bold">Quotation (Prefix & Next Serial)</label>
                                                <div className="input-group">
                                                    <input className="form-control" placeholder="Prefix" value={profile.qtnPrefix} onChange={e => setProfile({ ...profile, qtnPrefix: e.target.value })} />
                                                    <input type="number" className="form-control" placeholder="Next #" value={profile.qtnNext} onChange={e => setProfile({ ...profile, qtnNext: Number(e.target.value) })} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card bg-light border-0">
                                            <div className="card-body">
                                                <label className="form-label fw-bold">Proforma Invoice (Prefix & Next Serial)</label>
                                                <div className="input-group">
                                                    <input className="form-control" placeholder="Prefix" value={profile.profPrefix} onChange={e => setProfile({ ...profile, profPrefix: e.target.value })} />
                                                    <input type="number" className="form-control" placeholder="Next #" value={profile.profNext} onChange={e => setProfile({ ...profile, profNext: Number(e.target.value) })} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card bg-light border-0">
                                            <div className="card-body">
                                                <label className="form-label fw-bold">Delivery Chalan (Prefix & Next Serial)</label>
                                                <div className="input-group">
                                                    <input className="form-control" placeholder="Prefix" value={profile.dcPrefix} onChange={e => setProfile({ ...profile, dcPrefix: e.target.value })} />
                                                    <input type="number" className="form-control" placeholder="Next #" value={profile.dcNext} onChange={e => setProfile({ ...profile, dcNext: Number(e.target.value) })} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
